import { Table } from '@umu/umu-design';
import React, { Fragment } from 'react';
import { If, Loading } from 'common/src/components';
import { PaginationV2 } from '../../../../pagination/index';
import { IMultiCapabilityTemplateInfo } from '../../../interface/multiCapabilityTemplate';
import ListBlankPC from '../../../../ListBlank/ListBlankPC';

interface IProps {
    list: IMultiCapabilityTemplateInfo[];
    pageInfo: IPageInfo;
    columns: any[];
    emptyText?: string;
    isLoading?: boolean;
    onPageChange: (page: number) => void;
}

const TemplateTable = (props: IProps) => {
    const { list, columns, pageInfo, isLoading = false, emptyText = '', onPageChange } = props;
    const isEmpty = list.length === 0 && pageInfo.total_page_num <= 1;
    return (
        <div className="template-list">
            <If condition={isLoading}>
                <Loading />
            </If>
            <If condition={!isEmpty && !isLoading}>
                <Fragment>
                    <Table columns={columns} data={list} scroll={{ y: 280 }} emptyText={' '} />
                    <If condition={pageInfo.total_page_num > 1}>
                        <div className="capability-flex-col fix-right small-rows">
                            <PaginationV2
                                showSizeChanger
                                currentPage={pageInfo.current_page}
                                maxPage={pageInfo.total_page_num}
                                onPageChange={onPageChange}
                            />
                        </div>
                    </If>
                </Fragment>
            </If>
            <If condition={isEmpty && !isLoading}>
                <ListBlankPC type={2} className="template-empty-info" title={emptyText} />
            </If>
        </div>
    );
};
export { TemplateTable };
